export const ProgressBar = ({percentage})=>{
    return (
        <div className="progress-bar">
            <span className="bar">
                <span className="progress" style={{width:percentage+"%"}}></span>
            </span>
        </div>
    );
}